/**
 * RegisterRoute - Email entry for registration
 * Uses RegisterVM from AppContext
 * SocialLoginVM is accessed directly via useAppContext in the page
 */

import { withStoreProvider } from "@innolab-trader/vm-core";
import { RegisterStoreProvider } from "../models/register";
import { useAppContextStore } from "../models/appContext";
import RegisterPage from "../pages/RegisterPage";

export const RegisterRoute = withStoreProvider({
  useStore: () => useAppContextStore().actions.registerStore(),
  Provider: RegisterStoreProvider,
  Page: RegisterPage,
});
